import React from 'react';

import {ANNOTATION_SHIELD_EXEMPT_PROPS} from 'client/components/PracticeView/Annotations/shared/annotationFreeze';

export const RESIZER_DEFAULT_CLASSNAME = 'Resizer';

interface Props {
  children?: React.ReactNode;
  className: string;
  eleRef?: React.Ref<HTMLDivElement>;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onDoubleClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  onMouseDown: (event: React.MouseEvent<HTMLDivElement>) => void;
  onTouchEnd: (event: React.TouchEvent<HTMLDivElement>) => void;
  onTouchStart: (event: React.TouchEvent<HTMLDivElement>) => void;
  position?: number;
  resizerClassName?: string;
  split?: 'horizontal' | 'vertical';
  style?: React.CSSProperties;
}

class Resizer extends React.Component<Props> {
  static defaultProps = {
    resizerClassName: RESIZER_DEFAULT_CLASSNAME
  };

  render() {
    const {
      eleRef,
      children,
      className,
      onClick,
      onDoubleClick,
      onMouseDown,
      onTouchEnd,
      onTouchStart,
      onKeyDown,
      position,
      resizerClassName,
      split,
      style
    } = this.props;
    const classes = [resizerClassName, split, className];

    return (
      <div
        {...ANNOTATION_SHIELD_EXEMPT_PROPS}
        ref={eleRef}
        aria-label='resizer'
        tabIndex={0}
        role='slider'
        aria-valuenow={position}
        aria-orientation={split}
        className={classes.join(' ')}
        style={style}
        onMouseDown={(event) => onMouseDown(event)}
        onTouchStart={(event) => {
          event.preventDefault();
          onTouchStart(event);
        }}
        onTouchEnd={(event) => {
          event.preventDefault();
          onTouchEnd(event);
        }}
        onClick={(event) => {
          if (onClick) {
            event.preventDefault();
            onClick(event);
          }
        }}
        onDoubleClick={(event) => {
          if (onDoubleClick) {
            event.preventDefault();
            onDoubleClick(event);
          }
        }}
        onKeyDown={(event) => {
          onKeyDown(event);
        }}
      >
        {children}
      </div>
    );
  }
}

export default Resizer;
